const a = ["#d5d3da", "#898a9b", "#5a5c71", "#07040b"], d = ["#d5d3da", "#a2a1b0", "#707286", "#43465b", "#07040b"], b = [
  "#ffffff",
  "#d5d3da",
  "#a2a1b0",
  "#707286",
  "#43465b",
  "#07040b"
];
export {
  a as DEMOGRAPHICS_GRAY_4,
  d as DEMOGRAPHICS_GRAY_5,
  b as DEMOGRAPHICS_GRAY_6
};
//# sourceMappingURL=index.es5684.js.map
